"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../constants");
const styleOverrides = {
  root: ({
    ownerState
  }) => ({
    height: 8,
    borderRadius: 4,
    backgroundColor: _constants.colors.oriGrey.A100,
    ...(ownerState.color === 'inherit' && {
      '&::before': {
        backgroundColor: _constants.colors.oriGrey.A100
      }
    })
  }),
  bar: {
    borderRadius: 4
  },
  dashed: {
    backgroundSize: '10.8px 10.8px'
  },
  bar2Buffer: {
    opacity: 0.3
  },
  barColorPrimary: {
    backgroundColor: _constants.colors.error.main
  },
  dashedColorPrimary: {
    backgroundImage: `radial-gradient(${_constants.colors.error.main} 0%, ${_constants.colors.error.main} 16%, transparent 42%)`
  },
  barColorSecondary: {
    backgroundColor: _constants.colors.success.main
  },
  dashedColorSecondary: {
    backgroundImage: `radial-gradient(${_constants.colors.success.main} 0%, ${_constants.colors.success.main} 16%, transparent 42%)`
  }
};
var _default = exports.default = {
  styleOverrides
};
//# sourceMappingURL=MuiLinearProgress.js.map